/**
 * @module ol/webgl/ContextEventType
 */

/**
 * @enum {string}
 */
var ContextEventType = {
  LOST: 'webglcontextlost',
  RESTORED: 'webglcontextrestored',
};

export { ContextEventType as default };
//# sourceMappingURL=ContextEventType.js.map
